export const emptyRailCard = {Description: 'Please select...', Code: ''};

export default function UkrailCardsService() {
    const MAX_RAIL_CARDS_COUNT = 8;

    Object.assign(this, {
        initRailCardsCount,
        hasDuplicateRailCards,
        getLastIndex,
        railcardsApplied,
    });

    function railcardsApplied(ukRailCards) {
        return Array.isArray(ukRailCards)
            && ukRailCards.length > 0
            && !angular.equals(ukRailCards[0], emptyRailCard);
    }

    function initRailCardsCount() {
        return _.range(1, MAX_RAIL_CARDS_COUNT + 1).map((value) => ({text: value, value}));
    }

    function hasDuplicateRailCards(railCards) {
        return railCards.length !== Array.from(new Set(railCards)).length;
    }

    function getLastIndex(array) {
        return Array.isArray(array)
            && array.length > 0
            && array.length - 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/ukrail-cards/ukrail-cards-service.js